export const platformVersion = '^20.1.0';
